import { TrashIcon } from "@radix-ui/react-icons";
import { Callout, Flex, Text } from "@radix-ui/themes";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetStudentDocumentsQuery } from "../../hooks/useGetStudentDocumentsQuery";
import { useGetTeacheIdByUserId } from "../../hooks/useGetTeacheIdByUserId";
import { RootState } from "../../redux/store";
import { routes } from "../../routes";
import { updateStudentDocument } from "../../services/school/student/createStudent";
import { StudentDocumentType } from "../../types/Student";
import { Key_studentDocuments } from "../../utils/constants";


const columnNamesMap: { [key: string]: string } = {
  docType: "Tipo de documento",
  state: "Estado",
};

export const StudentDocuments = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { UserId } = useSelector((state: RootState) => state.login.userData)
  const { data: studentData } = useGetTeacheIdByUserId(UserId, { enabled: !!UserId });
  const { data, status } = useGetStudentDocumentsQuery({ PageNumber: currentPage, PageSize: 400, IdStudent: studentData?.idStudent }, {
    enabled: !!studentData?.idStudent
  });
  const [deleteItem, setDeleteItem] = useState<StudentDocumentType | null>(null);
  const mutationUpdate = useMutation(updateStudentDocument, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_studentDocuments);
      toast.success('Documento apagado');
    },
    onError: () => {
      toast.error("Erro ao apagar documento.")
    }
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.requestStudentDocument)
  }
  const handleDelete = (c: StudentDocumentType) => {
    c.status = false;
    mutationUpdate.mutateAsync(c)
  };
  const openDeleteDialog = (s: StudentDocumentType) => {
    setDeleteItem(s);
  };
  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!)
    }
  };

  const options = data?.items.map((c: StudentDocumentType) => [
    {
      label: 'Excluir',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

  if (!studentData || !studentData.idStudent) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Text>
            Entre como estudante &nbsp;
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Text>
        </Callout.Root>

      </Flex>
    );
  }

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        }
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
}
